import { render, staticRenderFns } from "./ManufacturingReports.vue?vue&type=template&id=228d5126"
import script from "./ManufacturingReports.vue?vue&type=script&lang=js"
export * from "./ManufacturingReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports